"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialNumber = exports.SerialNumbers = exports.createSerialNumberParser = exports.createCodeParser = exports.NAMESPACE = exports.TroubleshootingChat = exports.Vendor = exports.Session = exports.Report = exports.Ota = exports.Manufacturing = exports.History = exports.Class = exports.Capability = void 0;
const effect_1 = require("effect");
const azure_1 = require("../../azure");
const schema_1 = require("../../schema");
const Regex = __importStar(require("../../utils/regex"));
const Class = __importStar(require("./class"));
exports.Capability = __importStar(require("./capability"));
exports.Class = __importStar(require("./class"));
exports.History = __importStar(require("./history"));
exports.Manufacturing = __importStar(require("./manufacturing"));
exports.Ota = __importStar(require("./ota"));
exports.Report = __importStar(require("./report"));
exports.Session = __importStar(require("./session"));
exports.Vendor = __importStar(require("./vendor"));
exports.TroubleshootingChat = __importStar(require("./troubleshooting-chat"));
exports.NAMESPACE = 'Culligan.Device';
const serialPattern = (0, effect_1.pipe)(`[a-zA-Z0-9]+`, Regex.Pattern.namedCapturingGroup('serial'));
const Serial = effect_1.Schema.String.pipe(effect_1.Schema.pattern(new RegExp(Regex.Pattern.absolute(serialPattern), 'i'))).annotations({ identifier: `${exports.NAMESPACE}.Serial` });
const envCodes = (0, effect_1.pipe)(azure_1.Environment.enums, effect_1.Record.values);
const createCodePattern = (Device) => Regex.Pattern.join((0, effect_1.pipe)(Device.vendors, Regex.Pattern.oneOf, Regex.Pattern.namedCapturingGroup('vendor')), (0, effect_1.pipe)(Device.code, Regex.Pattern.namedCapturingGroup('model')), (0, effect_1.pipe)(
// FastCheck does not support generating values for RegExp Arbitraries
// that contain empty tokens (e.g. `()` for `Production`) within capturing groups
envCodes.filter(env => env !== azure_1.Environment.enums.Production), Regex.Pattern.oneOf, Regex.Pattern.namedCapturingGroup('env'), 
// The `Production` environment is represented by an empty string,
// so the `env` named capturing group is optional
Regex.Pattern.optional));
const createCodeRegExp = (Device) => new RegExp((0, effect_1.pipe)(Device, createCodePattern, Regex.Pattern.absolute), 'i');
const createCodeCaptureSchema = (Device) => effect_1.Schema.Struct({
    vendor: (0, schema_1.FromCaseAgnostic)(...Device.vendors),
    model: (0, schema_1.FromCaseAgnostic)(Device.code),
    env: effect_1.Schema.optionalWith((0, schema_1.FromCaseAgnostic)(...envCodes), {
        default: () => azure_1.Environment.enums.Production,
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.createCodeCaptureSchema<${Device.code}, [${Device.vendors.join(' | ')}]>`,
});
const createCodeTuple = (Device) => effect_1.Schema.Tuple(effect_1.Schema.Literal(...Device.vendors), effect_1.Schema.Literal(Device.code), effect_1.Schema.Literal(...envCodes)).annotations({
    identifier: `${exports.NAMESPACE}.createCodeTuple<${Device.code}, [${Device.vendors.join(' | ')}]>`,
});
const createCodeParser = (Device) => {
    const capturePattern = (0, schema_1.CapturePattern)(createCodeRegExp(Device), createCodeCaptureSchema(Device), ({ vendor, model, env }) => effect_1.Effect.succeed(`${vendor}${model}${env}`));
    return capturePattern
        .pipe(effect_1.Schema.transform(createCodeTuple(Device), {
        strict: true,
        decode: ({ vendor, model, env }) => [vendor, model, env],
        encode: ([vendor, model, env]) => ({ vendor, model, env }),
    }))
        .annotations({
        identifier: `${exports.NAMESPACE}.createCodeParser<${Device.code}, [${Device.vendors.join(' | ')}]>`,
    });
};
exports.createCodeParser = createCodeParser;
const createSerialNumberParser = (Device) => {
    const capturePattern = (0, schema_1.CapturePattern)(new RegExp(Regex.Pattern.absolute(createCodePattern(Device), '-', serialPattern), 'i'), createCodeCaptureSchema(Device).pipe(effect_1.Schema.extend(effect_1.Schema.Struct({ serial: Serial }))), ({ vendor, model, env, serial }) => effect_1.Effect.succeed([vendor, model, env, '-', serial].join('')));
    const transform = capturePattern
        .pipe(effect_1.Schema.transform(effect_1.Schema.Tuple(createCodeTuple(Device), effect_1.Schema.Literal('-'), Serial), {
        strict: true,
        decode: ({ vendor, model, env, serial }) => [[vendor, model, env], '-', serial],
        encode: ([[vendor, model, env], _, serial]) => ({ vendor, model, env, serial }),
    }))
        .annotations({
        identifier: `${exports.NAMESPACE}.createSerialNumberParser<${Device.code}, [${Device.vendors.join(' | ')}]>`,
    });
    // `transform`'s inferred Encoded type is the plain `string` produced by
    // `S.String.pipe(S.pattern(...))` inside `CapturePattern` — a regex refinement narrows
    // the runtime values it accepts, but TS can't express that narrowing as a template
    // literal type. The cast below restores the narrower public type; it is safe because
    // the regex passed to `CapturePattern` always requires a literal `-` between the code
    // and serial segments.
    return transform;
};
exports.createSerialNumberParser = createSerialNumberParser;
exports.SerialNumbers = {
    Blackbox: (0, exports.createSerialNumberParser)(Class.Blackbox.Blackbox).annotations({
        identifier: `${exports.NAMESPACE}.SerialNumbers.Blackbox`,
    }),
    Gbfc: (0, exports.createSerialNumberParser)(Class.Gbfc.Gbfc).annotations({
        identifier: `${exports.NAMESPACE}.SerialNumbers.Gbfc`,
    }),
    Htb: (0, exports.createSerialNumberParser)(Class.HydroTapBridge.HydroTapBridge).annotations({
        identifier: `${exports.NAMESPACE}.SerialNumbers.Htb`,
    }),
    Pelican2: (0, exports.createSerialNumberParser)(Class.Pelican2.Pelican2).annotations({
        identifier: `${exports.NAMESPACE}.SerialNumbers.Pelican2`,
    }),
    SyncRo: (0, exports.createSerialNumberParser)(Class.SyncRo.SyncRo).annotations({
        identifier: `${exports.NAMESPACE}.SerialNumbers.SyncRo`,
    }),
};
exports.SerialNumber = effect_1.Schema.Union(...effect_1.Record.values(exports.SerialNumbers)).annotations({
    identifier: `${exports.NAMESPACE}.SerialNumber`,
});
//# sourceMappingURL=index.js.map